import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";

import SidebarAdmin from "./Utils/SidebarAdmin";
import CreateDrives from "./Resource/CreateDrives";
import UpdateDrive from "./Resource/UpdateDrive";

import "./Dashboard.css";
import "./CreateDrive.css";
import { logout } from "../apis/backend";
import LogoutButton from "./LogoutButton";
import styles from "./Styles/CreateCertificate.module.css";
import apiConfig from "../config/apiConfig";
import { apiFetch } from "../apis/apiFetch";
import { toast } from "../utils/toast";

export default function CheckPaymentStatus() {
    const navigate = useNavigate();

    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [dataToSave, setDataToSave] = useState<any>(null)
    const [checkStatusRes, setCheckStatusResponse] = useState("")
    const [isChecking, setIsChecking] = useState(false)
    const [isUpdating, setIsUpdating] = useState(false)
    const [isGenerating, setIsGenerating] = useState(false)

    const handleCheck = async () => {
        try {
            setIsChecking(true)
            const url = `${apiConfig.API_BASE_URL}/payment/icici/checkStatus?queryId=GET&refNo=${dataToSave?.refNo}`;
            const response = await apiFetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            if (data) {
                setCheckStatusResponse(data)
            }
        } catch (err) {
            console.error("Error fetching payment status", err);
        } finally {
            setIsChecking(false)
        }
    }

    const handleUpdate = async () => {
        try {
            setIsUpdating(true)
            const url = `${apiConfig.API_BASE_URL}/payment/icici/updateStatus?queryId=GET&refNo=${dataToSave?.refNo}&appNo=${dataToSave?.appNo}`;
            const response = await apiFetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            if (data) {
                if (data.success === true) {
                    toast.success("Payment details updated");
                } else {
                    toast.error("Could not update payment status");
                }
            }
            console.log("dtaat", data)
        } catch (err) {
            toast.error("Could not update payment status");
            console.error("Error updating payment status", err);
        } finally {
            setIsUpdating(false)
        }
    }

    const handleManualUpdate = async () => {
        try {
            setIsUpdating(true)
            const url = `${apiConfig.API_BASE_URL}/payment/icici/manualUpdateStatus?queryId=GET&refNo=${dataToSave?.manualRefNo}&appNo=${dataToSave?.manualAppNo}&amount=${dataToSave?.amount}&txnId=${dataToSave?.txnId}`;
            const response = await apiFetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            if (data) {
                if (data.success === true) {
                    toast.success("Payment details updated");
                } else {
                    toast.error("Could not update payment status");
                }
            }
            console.log("dtaat", data)
        } catch (err) {
            toast.error("Could not update payment status");
            console.error("Error updating payment status", err);
        } finally {
            setIsUpdating(false)
        }
    }

    const handleGenerateInvoice = async () => {
        try {
            setIsGenerating(true)
            const url = `${apiConfig.API_BASE_URL}/payments/generateInvoice?queryId=GET&refNo=${dataToSave?.invoiceRefNo}&appNo=${dataToSave?.invoiceAppNo}&amount=${dataToSave?.invoiceAmount}&txnId=${dataToSave?.inoviceTxnId}`;
            const response = await apiFetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            if (data) {
                if (data.success === true) {
                    toast.success("Invoice Generated");
                } else {
                    toast.error("Could not generate invoice");
                }
            }
            console.log("dtaat", data)
        } catch (err) {
            toast.error("Could not generate invoice");
            console.error("Error generate invoice", err);
        } finally {
            setIsGenerating(false)
        }
    }
    const updateButtonDisabled = isChecking || isUpdating || !dataToSave?.appNo || !dataToSave?.refNo;

    const manualUpdateButtonDisabled = isChecking || isUpdating || !dataToSave?.manualRefNo || !dataToSave?.manualAppNo || !dataToSave?.amount || !dataToSave?.txnId;
    
    const generateInvoiceButtonDisabled = isGenerating || !dataToSave?.inoviceTxnId || !dataToSave?.invoiceRefNo || !dataToSave?.invoiceAmount || !dataToSave?.invoiceAppNo;

    return (
        <div className="dash-layout">
            {/* Sidebar */}
            <SidebarAdmin
                sidebarCollapsed={sidebarCollapsed}
                toggleSidebar={() => setSidebarCollapsed((p) => !p)}
            />

            {/* Main Wrapper */}
            <div
                className={`dash-wrapper ${sidebarCollapsed ? "dash-wrapper-collapsed" : ""
                    }`}
            >
                {/* Header */}
                <header className="dash-header">
                    <h1 className="dash-page-title">Payment Status</h1>

                    <div className="dash-user-profile">
                        <div
                            className="dash-profile-circle"
                            onClick={() => setShowDropdown((p) => !p)}
                        >
                            <span>A</span>
                        </div>

                        {showDropdown && (
                            <div className="dash-profile-dropdown">
                                <LogoutButton />
                            </div>
                        )}
                    </div>
                </header>

                {/* Page Content */}
                <div className="dash-content-body">
                    <div className={styles.batchformCard}>
                        <div className={styles.certificateFormWrapper}>

                            <div className={styles.formGrid}>
                                {/* Name */}
                                <div className={styles.formGroup}>
                                    <label className={styles.formLabel}>
                                        <span className={styles.required}>*</span> Payment Reference Number
                                    </label>
                                    <input
                                        className={styles.formControl}
                                        value={dataToSave?.["refNo"] || ""}
                                        onChange={(e) =>
                                            setDataToSave({ ...dataToSave, refNo: e.target.value })
                                        }
                                    />
                                </div>

                            </div>

                            <div className={styles.buttonRow}>
                                <button
                                    className={styles.primaryBtn}
                                    disabled={isChecking || isUpdating}
                                    onClick={handleCheck}
                                >
                                    {isChecking ? "Checking..." : "Check Status"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dash-content-body">
                    <div className={styles.batchformCard}>
                        <label className={styles.formLabel}>
                            Status: {" "}
                        </label>
                        {isChecking ?
                            <div>
                                Loading.....
                            </div> :
                            (checkStatusRes && <>
                                <div className={styles.certificateFormWrapper}>

                                    <div className={styles.formGrid}>
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>
                                                Payment Transaction Response: {" "}
                                            </label>
                                            <pre>
                                                {JSON.stringify(checkStatusRes, null, 2)}
                                            </pre>
                                        </div>
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label className={styles.formLabel}>
                                            <span className={styles.required}>*</span> Application Number
                                        </label>
                                        <input
                                            className={styles.formControl}
                                            value={dataToSave?.["appNo"] || ""}
                                            onChange={(e) =>
                                                setDataToSave({ ...dataToSave, appNo: e.target.value })
                                            }
                                        />
                                    </div>
                                    <div className={styles.buttonRow}>
                                        <button
                                            className={styles.primaryBtn}
                                            style={updateButtonDisabled ? { backgroundColor: "grey" } : {}}
                                            disabled={updateButtonDisabled}
                                            onClick={handleUpdate}
                                        >
                                            {isUpdating ? "Updating..." : "Update Status"}
                                        </button>
                                    </div>
                                </div>
                            </>)
                        }
                    </div>
                </div>
                <div className="dash-content-body">
                    <div className={styles.batchformCard}>
                        <label className={styles.formLabel}>
                            Manual Update: {" "}
                        </label>
                        {isChecking ?
                            <div>
                                Loading.....
                            </div> :
                            (<>
                                <div className={styles.certificateFormWrapper}>

                                    <div className={styles.formGrid}>
                                        {/* Name */}
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>
                                                <span className={styles.required}>*</span> Application Number
                                            </label>
                                            <input
                                                className={styles.formControl}
                                                value={dataToSave?.["manualAppNo"] || ""}
                                                onChange={(e) =>
                                                    setDataToSave({ ...dataToSave, manualAppNo: e.target.value })
                                                }
                                            />
                                        </div>
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>
                                                <span className={styles.required}>*</span> Amount
                                            </label>
                                            <input
                                                className={styles.formControl}
                                                value={dataToSave?.["amount"] || ""}
                                                onChange={(e) =>
                                                    setDataToSave({ ...dataToSave, amount: e.target.value })
                                                }
                                            />
                                        </div>
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>
                                                <span className={styles.required}>*</span> Payment Reference Number
                                            </label>
                                            <input
                                                className={styles.formControl}
                                                value={dataToSave?.["manualRefNo"] || ""}
                                                onChange={(e) =>
                                                    setDataToSave({ ...dataToSave, manualRefNo: e.target.value })
                                                }
                                            />
                                        </div>
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>
                                                <span className={styles.required}>*</span> Payment Transaction ID
                                            </label>
                                            <input
                                                className={styles.formControl}
                                                value={dataToSave?.["txnId"] || ""}
                                                onChange={(e) =>
                                                    setDataToSave({ ...dataToSave, txnId: e.target.value })
                                                }
                                            />
                                        </div>

                                    </div>
                                    <div className={styles.buttonRow}>
                                        <button
                                            className={styles.primaryBtn}
                                            style={manualUpdateButtonDisabled ? { backgroundColor: "grey" } : {}}
                                            disabled={manualUpdateButtonDisabled}
                                            onClick={handleManualUpdate}
                                        >
                                            {isUpdating ? "Updating..." : "Update Status"}
                                        </button>
                                    </div>
                                </div>
                            </>)
                        }
                    </div>
                </div>
                <div className="dash-content-body">
                    <div className={styles.batchformCard}>
                        <label className={styles.formLabel}>
                            Update Invoice: {" "}
                        </label>
                        {isGenerating ?
                            <div>
                                Loading.....
                            </div> :
                            (<>
                                <div className={styles.certificateFormWrapper}>

                                    <div className={styles.formGrid}>
                                        {/* Name */}
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>
                                                <span className={styles.required}>*</span> Application Number
                                            </label>
                                            <input
                                                className={styles.formControl}
                                                value={dataToSave?.["invoiceAppNo"] || ""}
                                                onChange={(e) =>
                                                    setDataToSave({ ...dataToSave, invoiceAppNo: e.target.value })
                                                }
                                            />
                                        </div>
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>
                                                <span className={styles.required}>*</span> Amount
                                            </label>
                                            <input
                                                className={styles.formControl}
                                                value={dataToSave?.["invoiceAmount"] || ""}
                                                onChange={(e) =>
                                                    setDataToSave({ ...dataToSave, invoiceAmount: e.target.value })
                                                }
                                            />
                                        </div>
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>
                                                <span className={styles.required}>*</span> Payment Reference Number
                                            </label>
                                            <input
                                                className={styles.formControl}
                                                value={dataToSave?.["invoiceRefNo"] || ""}
                                                onChange={(e) =>
                                                    setDataToSave({ ...dataToSave, invoiceRefNo: e.target.value })
                                                }
                                            />
                                        </div>
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>
                                                <span className={styles.required}>*</span> Payment Transaction ID
                                            </label>
                                            <input
                                                className={styles.formControl}
                                                value={dataToSave?.["inoviceTxnId"] || ""}
                                                onChange={(e) =>
                                                    setDataToSave({ ...dataToSave, inoviceTxnId: e.target.value })
                                                }
                                            />
                                        </div>

                                    </div>
                                    <div className={styles.buttonRow}>
                                        <button
                                            className={styles.primaryBtn}
                                            style={generateInvoiceButtonDisabled ? { backgroundColor: "grey" } : {}}
                                            disabled={generateInvoiceButtonDisabled}
                                            onClick={handleGenerateInvoice}
                                        >
                                            {isGenerating ? "Generating..." : "Generate Invoice"}
                                        </button>
                                    </div>
                                </div>
                            </>)
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
